import React from 'react';
import holidaysvg from '../../../assets/icons/Feries (1).svg';
import closedsvg from '../../../assets/icons/Ferme (1).svg';
import holidayIcon from '../../../assets/icons/Holiday Calendar.svg';
import increasesvg from '../../../assets/icons/Increase.svg';
import reductionsvg from '../../../assets/icons/Reduction (1).svg';
import tastingEventIcon from '../../../assets/icons/tasting Event.svg';
import pholidaysvg from '../../../assets/icons/Vacances (1).svg';
import cancelledicon from '../../../assets/images/canceled.png';
import confirmedIcon from '../../../assets/images/Confirmed.png';
import pendingicon from '../../../assets/images/pending.png';
import useIsMobile from '../../../hooks/utils/useIsMobile';

interface CreateIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  iconSrc: string;
}

export const CreateIcon: React.FC<CreateIconProps> = ({
  iconSrc,
  style,
  ...rest
}) => {
  const isMobile = useIsMobile();
  return (
    <img
      src={iconSrc}
      style={{
        width: isMobile ? '40%' : '80%',
        height: '80%',
        objectFit: 'contain',
        ...style,
      }}
      {...rest}
    />
  );
};

export const ClosedIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={closedsvg} {...props} />;
};

export const ReductionIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={reductionsvg} {...props} />;
};

export const IncreaseIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={increasesvg} {...props} />;
};

export const PHolidaysIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={holidaysvg} {...props} />;
};

export const HolidaysIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={pholidaysvg} {...props} />;
};

export const PendingIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={pendingicon} {...props} />;
};

export const CancelledIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={cancelledicon} {...props} />;
};
export const ConfirmedIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return <CreateIcon iconSrc={confirmedIcon} {...props} />;
};

export const HolidayIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = props => {
  return (
    <CreateIcon
      iconSrc={holidayIcon}
      style={{ height: '16px', width: '16px' }}
      {...props}
    />
  );
};

export const TestingIcon: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = ({ width = '20px', height = '20px', ...restProps }) => {
  return (
    <CreateIcon
      iconSrc={tastingEventIcon}
      style={{ height, width }}
      {...restProps}
    />
  );
};
